import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomTooltip from '../CustomTooltip';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description Mini button with background color or without color
 * @param String id: Button identifier (required).
 * @param String title: Title of button (required).
 * @param event onClick: Click event on the button (optional).
 * @param String url: Navigation URL (optional).
 * @param {JSX.Element} Icon: Icon component (required).
 * @param String className: Style class for the button or default style class declared (optional).
 * @param Boolean disabled: Variable to disable the button (required).
 * @param String iconProps: Two style classes for the icon, one for size and another for color, or default styles initialized
 * @returns {JSX.Element}
 */
const ButtonIcon = (props) => {
    const { id = 'btn-hsb-mini', title = '', onClick = null, url = '', Icon, className = 'btn-icon-add', disabled = false, iconProps = 'btn-icon-svg-white btn-icon-svg-12px', tooltipPlacement='bottom' } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <> {title !== '' ?
            <CustomTooltip text={t(title)} placement={tooltipPlacement}>
                <button
                    id={id}
                    className={`btn-mini-icon-svg ${className}`}
                    disabled={disabled}
                    onClick={(e) => {
                        if (onClick !== null) onClick(e);
                        if (url !== '') navigate(url);
                    }}
                >
                    {Icon && <Icon className={` ${iconProps}`} />}
                </button>
            </CustomTooltip>
            :
            <button
                id={id}
                className={`btn-mini-icon-svg ${className}`}
                disabled={disabled}
                onClick={(e) => {
                    if (onClick !== null) onClick(e);
                    if (url !== '') navigate(url);
                }}
            >
                {Icon && <Icon className={` ${iconProps}`} />}
            </button>
        }
        </>
    );
};

export default ButtonIcon;
